/**
 * Cookie Consent Banner - Appmor Wrapper
 *
 * Thin wrapper around @boosting/ui-kit CookieConsentBanner
 * that integrates with appmor's analytics service.
 */

import React from 'react';
import { CookieConsentBanner as UiKitCookieConsentBanner } from '@boosting/ui-kit';
import type { CookieConsentState } from '@boosting/ui-kit';
import { grantAnalyticsConsent, denyAnalyticsConsent } from '@/core/services/analytics';

export const CookieConsentBanner: React.FC = () => {
    const handleConsentChange = (consent: CookieConsentState) => {
        if (consent.analytics) {
            grantAnalyticsConsent();
        } else {
            denyAnalyticsConsent();
        }
    };

    return (
        <UiKitCookieConsentBanner
            onConsentChange={handleConsentChange}
            storageKey="appmor_cookie_consent"
            consentVersion="1.0"
        />
    );
};

export default CookieConsentBanner;
